export default __webpack_public_path__ + "static/media/Strugani 12.8fd856e6.jpg";